import styled from '@emotion/styled';
import Text from '@molecules/Text';
import { ThemeColors } from '@theme/foundations/colors';
import ScreenSize from '../../../constants/screen-sizes';

export const StyledCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px 24px;

  .text-decoration {
    text-decoration-line: line-through;
  }

  .text-underline {
    text-decoration-line: underline;
  }

  .add-button {
    border: 2px solid #32C0A0;
    font-weight: 500;
    font-size: 14px;
  }

  .remove-button {
    border: 2px solid ${ThemeColors.error[500]};
    font-weight: 500;
    font-size: 14px;
  }

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    flex-direction: column;
    padding: 16px;
    gap: 32px;

    .add-button {
      font-size: 16px;
    }

    .remove-button {
      font-size: 16px;
    }
  }
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  min-width: 200px;
  width: 200px;
  height: 140px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 100%;
    height: 239px;
  }
`;

export const StyledMark = styled(Text)`
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: ${ThemeColors.white[500]};
  border-radius: 24px;
  padding: 2px 12px;
  white-space: nowrap;
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledText = styled(Text)`
  margin-bottom: 12px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    margin-bottom: 24px;
  }
`;
